export const GET_INSTRUCTIONS_API = `/patient/patient-get-lims-instructions`;
